if (typeof google !== 'undefined') {
    jQuery(function($) {
    var delayTimer;
    var map = null; // Initialize the map variable as null
    var currentMarker = null; // Variable to hold the currently open marker

    function clearURLParams() {
        if (window.history.replaceState) {
            const newURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState(null, null, newURL);
        }
    }

    function selectCheckboxesFromURL() {
        const params = new URLSearchParams(window.location.search);
        params.getAll("aluefilter[]").forEach(value => {
            let checkbox = document.querySelector(`input[name="aluefilter[]"][value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });
        params.getAll("kategoriafilter[]").forEach(value => {
            let checkbox = document.querySelector(`input[name="kategoriafilter[]"][value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });
        if (params.has("tarjousfilter")) {
            let checkbox = document.querySelector(`input[name="tarjousfilter[]"][value=""]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        }

        // Handle search input (hakusanakentta)
        if (params.has("search-input")) {
            let searchField = document.getElementById("hakusanakentta");
            if (searchField) {
                searchField.value = params.get("search-input"); // Set value from URL
            }
        }

        setupSelection();


        // Clear the URL parameters after processing
        clearURLParams();
    }

    function sendRequest() {
        var filter = $('#filter');
        $('#kohteidenmaara').hide();
        $('#loading').show();
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            dataType: 'json', // Set the expected response data type
            success: function(response) {
                $('#response').html(response.result);
                var postCount = response.post_count;
                $('#maaranumero').text(postCount); // Change the text of the span element


                var newLocations = response.locations;
                updateMarkers(newLocations);

                // Replace history state to prevent form resubmission on back navigation
                if (window.history.replaceState) {
                    window.history.replaceState(null, null, window.location.href);
                }

            },
            complete: function() {
                // Hide the loading GIF image after the request is complete
                $('#loading').hide();
                $('#kohteidenmaara').show();
            }
        });
    }

    function updateMarkers(locations) {
        if (map === null) {
            return;
        }

        // Remove existing markers from the map
        for (var i = 0; i < map.markers.length; i++) {
            map.markers[i].setMap(null);
        }

        // Add new markers to the map
        if (locations) {
        for (var j = 0; j < locations.length; j++) {
            var location = locations[j];
            var marker = new google.maps.Marker({
                position: { lat: location.latitude, lng: location.longitude },
                map: map
            });

            // If location content exists, create an info window for the marker
            if (location.content) {
                var infowindow = new google.maps.InfoWindow();

                // Show info window when marker is clicked
                marker.addListener('click', function (marker, infowindow) {
                    return function () {

                        // Close the previously open marker
                        if (currentMarker) {
                            currentMarker.infowindow.close();
                        }

                        infowindow.setContent(marker.content);
                        infowindow.open(map, marker);

                        // Update the currently open marker
                        currentMarker = {
                            marker: marker,
                            infowindow: infowindow
                        };

                    };
                }(marker, infowindow)); // Use a closure to preserve the values of marker and infowindow

                // Assign the content to the marker
                marker.content = location.content;
            }

            // Push the new marker to the map markers array
            map.markers.push(marker);
        }
        }

        // Center the map based on the new markers only if the map is currently visible
        if (googlemapDiv.style.display !== 'none') {
            centerMap();
        }
    }




    function centerMap() {
        if (map === null || map.markers.length === 0) {
            return; // Check if map is null or there are no markers, and return if true
        }

        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function(marker) {
            bounds.extend(marker.getPosition());
        });
        map.fitBounds(bounds);
    }

    // Initialize the map
    function initMap() {
        map = new google.maps.Map(document.getElementById('acf-map'), {
            zoom: 14,
            mapTypeId: "roadmap",//google.maps.MapTypeId.ROADMAP
        });
        map.markers = []; // Initialize an empty array for markers
    }

    selectCheckboxesFromURL(); // Select checkboxes based on URL params
    sendRequest();
    initMap();

   // sendRequest(); // Send the initial request when the page finishes loading

    $('#filter input:not(.naytakartta), #filter select, .suomikartta .aluekohta').on('keyup change click', function() {
        clearTimeout(delayTimer); // Clear the previous timer
        delayTimer = setTimeout(sendRequest, 500); // Set a delay of 500 milliseconds before sending the request
    });

    var input = document.getElementById("hakusanakentta");

    input.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent form submission
      }
    });
});

}
